import React, {
  forwardRef,
  HTMLAttributes,
  ReactNode,
  Ref,
  RefObject,
} from "react";

import classNames from "classnames";

import { StyledPaper } from "./Styles";

export interface IPaperProps {
  /** Children type of node or string */
  children: ReactNode;
  /** CSS classes */
  className?: string;
  /** Ref object. */
  innerRef?: RefObject<HTMLDivElement>;
  /** Define custom style */
  style?: object;
  /** Type of paper to be used */
  type?: "paper-1" | "paper-2" | "paper-3" | "tile-1" | "tile-2";
  /** Paper has hover or not */
  hover?: boolean;
  /** Use optimized shadow */
  useOptimizedShadow?: boolean;
}

/**
 * This is a component description and should sit directly above your component
 */
export const Paper = forwardRef(
  (
    {
      children,
      className,
      type = "paper-1",
      hover = false,
      useOptimizedShadow = false,
      ...rest
    }: HTMLAttributes<HTMLDivElement> & IPaperProps,
    innerRef: Ref<HTMLDivElement> | null | undefined
  ) => {
    return (
      <StyledPaper
        className={classNames(className, {
          "ac-shadow--raised--lg":
            !useOptimizedShadow && hover && type === "paper-1",
          "ac-shadow-optimized--lg":
            useOptimizedShadow && hover && type === "paper-1",
          "ac-shadow--lg": !hover && type === "paper-1",
          "ac-shadow--raised--sm":
            (!useOptimizedShadow && hover && type === "paper-2") ||
            (!useOptimizedShadow && hover && type === "paper-3"),
          "ac-shadow-optimized--sm":
            (useOptimizedShadow && hover && type === "paper-2") ||
            (useOptimizedShadow && hover && type === "paper-3"),
          "ac-shadow--sm":
            (!hover && type === "paper-2") || (!hover && type === "paper-3"),
        })}
        ref={innerRef}
        type={type}
        {...rest}
      >
        {children}
      </StyledPaper>
    );
  }
);

Paper.displayName = "Paper";
